import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';
import { RootRedirectGuard, SessionExpiredGuard } from '../app/core/guards';
import { AuthRoutingModule } from './pages/auth/auth-routing.module';

let routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/landing-page/landing-page.module').then(m => m.LandingPageModule),
    data: { title: 'ROUTES.HOME' },
    canActivate: [RootRedirectGuard],
  },
  {
    path: 'panel',
    canActivate: [SessionExpiredGuard],
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: { title: 'ROUTES.DASHBOARD' },
  },
  {
    path: 'form/:id',
    loadChildren: () => import('./pages/ui-form-viewer/ui-form-viewer.module').then(m => m.UiFormViewerModule),
    data: { title: 'ROUTES.FORM VIEWER' },
  },
  /*{
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/onboarding.component').then(m => m.OnboardingComponent),
    data: { title: 'ROUTES.ONBOARDING' },
    canActivate: [SessionExpiredGuard],
  },*/
  {
    path: 'automations/add',
    loadChildren: () =>
      import('./pages/dashboard/pages/automations/automation-add/automation-add.module').then(
        m => m.AutomationAddModule
      ),
    data: { title: 'ROUTES.AUTOMATIONS' },
  },
  {
    path: 'automations/:id/success',
    loadChildren: () =>
      import('./pages/dashboard/pages/automations/automation-success/automation-success.module').then(
        m => m.AutomationSuccessModule
      ),
    data: { title: 'ROUTES.AUTOMATIONS' },
  },
  {
    path: 'automations/add',
    loadChildren: () =>
      import('./pages/dashboard/pages/automations/automation-add/automation-add.module').then(
        m => m.AutomationAddModule
      ),
    data: { title: 'ROUTES.AUTOMATIONS' },
  },
  {
    path: 'automations/:id/success',
    loadChildren: () =>
      import('./pages/dashboard/pages/automations/automation-success/automation-success.module').then(
        m => m.AutomationSuccessModule
      ),
    data: { title: 'ROUTES.AUTOMATIONS' },
  },
  {
    path: 'openpay-callback',
    loadChildren: () => import('./pages/openpay-callback/openpay-callback.module').then(m => m.OpenpayCallbackModule),
    data: { title: 'Payment Callback' },
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];

if (environment.maintenance && environment.production) {
  routes = [
    {
      path: 'maintenance',
      loadChildren: () => import('./pages/maintenance/maintenance.module').then(m => m.MaintenanceModule),
      title: 'ROUTES.MAINTENANCE',
    },
    {
      path: '**',
      pathMatch: 'full',
      redirectTo: '/maintenance',
    },
  ];
}

let routerImports = [RouterModule.forRoot(routes), AuthRoutingModule];

if (environment.env === 'pages') {
  routerImports = [RouterModule.forRoot(routes, { useHash: true }), AuthRoutingModule];
}

@NgModule({
  imports: routerImports,
  exports: [RouterModule],
})
export class AppRoutingModule {}
